import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Kai Faust
 * id C92D4248-E908-4B39-A6D0-296E6FB5FFE1
 * name shape-rectangle-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-rectangle-plus.svg
 * tags
 * - Shape 
 */
export const ShapeRectanglePlusIcon = createSvgIcon(<><path d="M19,6H22V8H19V11H17V8H14V6H17V3H19V6M17,17V14H19V19H3V6H11V8H5V17H17Z" /></>, 'ShapeRectanglePlusIcon');
export default ShapeRectanglePlusIcon